// Beep corto (dos tonos ascendentes) al confirmar un registro de
// Entrada/Salida/Validación — sea manual (botón "Confirmar") o automático
// (ver AUTO_CONFIRM_DELAY_MS en ScannerShell). Sintetizado con Web Audio
// API en vez de un archivo .mp3/.wav: no hay ningún asset que cargar ni
// servir, y el navegador nunca tiene que esperar una descarga antes del
// primer beep.
let sharedCtx = null;

export const playConfirmSound = () => {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    if (!sharedCtx) sharedCtx = new Ctx();
    // Los navegadores arrancan el AudioContext "suspended" hasta el primer
    // gesto del usuario — en este flujo siempre hubo uno (tocar la pantalla
    // para escanear/buscar/confirmar) antes de llegar acá, así que esto casi
    // nunca hace falta, pero no cuesta nada intentarlo igual.
    if (sharedCtx.state === 'suspended') sharedCtx.resume().catch(() => {});

    const ctx = sharedCtx;
    const now = ctx.currentTime;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(880, now);
    osc.frequency.setValueAtTime(1175, now + 0.09);
    // Rampa exponencial (no lineal) para que el ataque/caída no suene como
    // un "click" — el volumen nunca llega a 0 exacto porque
    // exponentialRampToValueAtTime no acepta 0 como destino.
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.35, now + 0.015);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.22);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(now);
    osc.stop(now + 0.24);
  } catch {
    // Sin Web Audio (navegador viejo/política restrictiva) — el registro
    // igual se confirma normalmente, solo sin sonido.
  }
};
